export const SETTING_FINANCE_COLUMN = 'SETTING_FINANCE_COLUMN';
export const SETTING_FINANCE_INDEX = 'SETTING_FINANCE_INDEX';
export const SETTING_FINANCE_LOADING_INDEX = 'SETTING_FINANCE_LOADING_INDEX';
export const SETTING_FINANCE_LOADING_SHOW = 'SETTING_FINANCE_LOADING_SHOW';
export const SETTING_FINANCE_RESET = 'SETTING_FINANCE_RESET';
export const SETTING_FINANCE_SEARCH = 'SETTING_FINANCE_SEARCH';
export const SETTING_FINANCE_SHOW = 'SETTING_FINANCE_SHOW';
export const SETTING_FINANCE_COLLECT = 'SETTING_FINANCE_COLLECT';
